import { ChangeDetectionStrategy, Component, computed, inject, signal, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import type { Module } from '../../../features/admin/modules/modules.model';
import { FormlyErrorComponent } from '../formly-error.component';
import { DynamicOptionsService } from './services/dynamic-options.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { FormlyDataCyDirective } from '../../directives/formly-data-cy.directive';
import { FieldLabelRowComponent } from './field-label-row.component';
import { commitUserValue } from './user-edit.util';

@Component({
  selector: 'formly-field-segment-buttons',
  template: `
    <div [formlyDataCy]="field">
      <mat-label class="font-medium text-default">
        <app-field-label-row [label]="props.label" [required]="props.required"></app-field-label-row>
        @if (isLoading()) {
          <mat-spinner class="absolute right-8" diameter="24"> </mat-spinner>
        }
      </mat-label>
      <div class="flex segment-buttons">
        @for (option of availableOptions(); track $index) {
          <button
            type="button"
            [disabled]="isDisabled()"
            class="flex-1 truncate"
            [ngClass]="
              (formControl.value?.id && formControl.value?.id === option.value?.id) ||
              formControl.value === option.value
                ? 'font-semibold'
                : ''
            "
            [class.active]="
              (formControl.value?.id && formControl.value?.id === option.value?.id) ||
              formControl.value === option.value
            "
            mat-flat-button
            (click)="updateValue(option.value)">
            {{ option.label }}
          </button>
        }
      </div>
    </div>
    @if (field.props.description) {
      <mat-hint class="inline-block mb-2">{{ field.props.description }}</mat-hint>
    }
    <app-formly-error [field]="field"></app-formly-error>
  `,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule,
    MatInputModule,
    MatButtonModule,
    FormlyErrorComponent,
    MatProgressSpinner,
    FormlyDataCyDirective,
    FieldLabelRowComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldSegmentButtons extends FieldType implements OnInit {
  availableOptions = signal<Array<{ label: string; value: any; group: string }>>([]);
  isLoading = signal(true);
  loaded = signal(false);
  dynamicOptionsService = inject(DynamicOptionsService);
  moduleId: Module['id'];
  isDisabled = computed(() => {
    return this.field.props?.['disabled'] || this.form.disabled;
  });
  constructor() {
    super();
  }

  ngOnInit() {
    this.moduleId = this.options.formState?.entity?.id;
    this.initializeOptions();
  }

  private initializeOptions(): void {
    this.dynamicOptionsService.initializeOptions(this.field).subscribe(options => {
      this.availableOptions.set(options);
      this.isLoading.set(false);
      this.loaded.set(true);
    });
  }

  updateValue(value: any) {
    commitUserValue(this.formControl, JSON.parse(JSON.stringify(value)));
  }
}
